// components/favicon-handler.tsx
import { useEffect } from 'react'

const useFavicon = () => {
  useEffect(() => {
    const setFavicon = () => {
      const hostname = window.location.hostname
      const isLucySubdomain = hostname.startsWith('minhalucy.')

      const link =
        (document.querySelector("link[rel*='icon']") as HTMLLinkElement) ||
        document.createElement('link')

      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = isLucySubdomain
        ? '/images/favicon_lucy.ico'
        : '/images/favicon.ico'

      document.head.appendChild(link)
    }

    setFavicon()
  }, [])
}

export const FaviconHandler = () => {
  useFavicon()
  return null
}
